export default __webpack_public_path__ + "public/markdown/cases/travel/case.md";